import { Country, ErrorCode } from '@afterpaytouch/portal-api/types'
import { SupportedLocale } from '@afterpay/types'
import { FetchVerificationErrorResponse, FetchVerificationWaitResponse } from '@afterpaytouch/event-verify'

export type Mobile = string

export type Email = string

export type RegistrationId = string

export type Code = string

// TODO remove this and use the types from the packages/registration package
export interface RegistrationData {
  address1: string
  address2?: string
  area2: string
  countryCode: Country
  dateOfBirth: string
  givenNames: string
  mobile: Mobile
  email: string
  otherGivenNames: string
  postcode: string
  state?: string
  suburb: string
  surname: string
  preferredLocale: SupportedLocale
  creditPolicyAgree?: boolean
  creditCheckAgree?: boolean
  marketingOptIn?: boolean
}

export type CreateAccountRequest = Omit<RegistrationData, 'creditPolicyAgree' | 'countryCode'> & {
  countryCode: string
}
// Strings should match the localisations in `signUp`
export enum RegistrationErrorCode {
  Default = 'default',
  InvalidAddress = 'invalidAddress',
  ExistingPhoneNumber = 'existingPhoneNumber',
  ExistingPhoneNumberSendEmail = 'existingPhoneNumberSendEmail',
  DuplicateIdentity = 'duplicateIdentity',
  IdentityCheckRejected = 'identityCheckRejected',
  MaxAttemptsReachedForType = 'maxAttemptsReachedForType',
  HighRiskNationality = 'highRiskNationality',
}

export const registrationErrors: Partial<Record<ErrorCode, RegistrationErrorCode>> = {
  [ErrorCode.IneligibleState]: RegistrationErrorCode.InvalidAddress,
  [ErrorCode.InvalidAddress]: RegistrationErrorCode.InvalidAddress,
  [ErrorCode.AddressPoBoxNotAllowed]: RegistrationErrorCode.InvalidAddress,
  [ErrorCode.InvalidObject]: RegistrationErrorCode.InvalidAddress,
  [ErrorCode.ExistingPhoneNumber]: RegistrationErrorCode.ExistingPhoneNumber,
  [ErrorCode.ExistingPhoneNumberSendEmail]: RegistrationErrorCode.ExistingPhoneNumberSendEmail,
  [ErrorCode.DuplicateIdentity]: RegistrationErrorCode.DuplicateIdentity,
  [ErrorCode.IdentityCheckRejected]: RegistrationErrorCode.IdentityCheckRejected,
  [ErrorCode.MaxAttemptsReachedForType]: RegistrationErrorCode.MaxAttemptsReachedForType,
  [ErrorCode.HighRiskNationality]: RegistrationErrorCode.HighRiskNationality,
}

export interface VerifyRegistrationMobileEventRequest {
  onSuccess: () => void
  onError: (d: FetchVerificationErrorResponse) => void
  onWaiting: (d: FetchVerificationWaitResponse) => void
}

export interface VerifyRegistrationAuthorizationRequest {
  registrationId: RegistrationId
  amplitudeSessionId: number
  consumer: RegistrationData
  portalToken: string
}

export interface VerifyRegistrationSMSAuthorizationResponse {
  code: VerifyRegistrationSMSAuthorizationCode
  message: VerifyRegistrationSMSAuthorizationMessage
}

export enum VerifyRegistrationSMSAuthorizationCode {
  OK = 'OK',
  FAILED = 'FAILED',
}

export enum VerifyRegistrationSMSAuthorizationMessage {
  SUCCESS = 'SUCCESS',
  UNKNOWN = 'UNKNOWN',
  INVALID_REQUEST_PAYLOAD = 'INVALID_REQUEST_PAYLOAD',
}

export interface AddMobileToRegistrationRequest {
  registrationId: RegistrationId
  mobile: Mobile
  smsCode: Code
}

export interface AddEmailToRegistrationRequest {
  registrationId: RegistrationId
  email: Email
  emailCode: Code
}

export interface ConfirmRegistrationRequest {
  registrationId: RegistrationId
  origin: 'CONSUMER_PORTAL' | 'CHECKOUT' | 'MOBILE' | 'UNKNOWN'
  preferredLocale: SupportedLocale
  marketingPreference?: boolean
}

export interface FinaliseAccountRequest {
  address1: string
  address2?: string
  area2: string
  countryCode: Country
  dateOfBirth: string
  givenNames: string
  mobile: Mobile
  otherGivenNames: string
  postcode: string
  state?: string
  suburb: string
  surname: string
  creditPolicyAgree?: boolean
  creditCheckAgree?: boolean
  providedCreditCheckConsent?: boolean
}
